import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SERVER_URL } from "../config/config";
import { boolean } from "yargs";
import MemberServices from "../services/MemberServices";
import IMember from "./memberInterfaceStruct";

const serverURL = SERVER_URL;

// interface IState {
//   [key: string]: any;
// }

// interface IAddress {
//   Id: number | null;
//   MemberId: number;
//   FirmName: string | null;
//   Address1: string | null;
//   Address2: string | null;
//   County: string | null;
//   State: string | null;
//   Zipcode: number | null;
//   PhoneNumber: string | null;
//   FaxNumber: string | null;
//   Email: string | null;
//   AddressType: string | null;
//   CreatedAt: string | null;
//   UpdatedAt: string | null;
// }

// interface IMemberSections {
//   Id: number | null;
//   SectionName: string | null;
//   MemberId: number | null;
// }
// interface IMemberTags {
//   Id: number | null;
//   MemberTag: string | null;
//   MemberId: number | null;
// }
// interface IOtherStateBar {
//   Id: number | null;
//   MemberId: number | null;
//   OtherStateBarName: string | null;
//   AdmitDate: string | null;
//   BarId: null;
//   Status: number | null;
//   CreatedAt: string | null;
//   UpdatedAt: string | null;
// }

// interface IMember {
//   Id: number | null;
//   BarId: string | null;
//   MemberTypeId: number | null;
//   MemberCodeId: number | null;
//   Title: string | null;
//   Esquire: string | null;
//   FirstName: string | null;
//   LastName: string | null;
//   Gender: string | null;
//   DateOfBirth: string | null;
//   AdmitDate: string | null;
//   Comments: string | null;
//   IsValidSupremeCourtId: number | null;
//   IsMediator: number | null;
//   MediatorCertificationEndsOn: string | null;
//   CreatedAt: string | null;
//   UpdatedAt: string | null;
//   MemberType: string | null;
//   MemberCode: string | null;
//   Description: string | null;
//   address: IAddress[] | null;
//   memberSections: IMemberSections[] | null;
//   memberTags: IMemberTags[] | null;
//   otherStateBar: IOtherStateBar[] | null;
// }

interface IAPIResponse {
  data: IMember[] | null;
  status: boolean | null;
  hasErrors: boolean | null;
  errors: string[] | null;
}

type initialMemberListState = {
  loading: boolean;
  members: IMember[];
  error: String;
};

const initialMemberListState: initialMemberListState = {
  loading: false,
  members: [],
  error: "",
};

export const findMembers = createAsyncThunk(
  "member/findmembers",
  async (searchParameters: any) => {
    console.log("searchParameters", searchParameters);
    // let axiosConfig = {
    //   headers: {
    //     "Content-Type": "application/json;charset=UTF-8",
    //     ApiKey: process.env.REACT_APP_API_KEY,
    //     SessionToken: sessionStorage.getItem("DsbaAdminToken"),
    //   },
    // };
    // return axios
    //   .get(`${serverURL}/api/member`, axiosConfig)
    //   .then((response) => response.data.data);

    return MemberServices.getMemberList(searchParameters).then(
      (response) => response.data.data
    );
  }
);

export const findMemberSearchResultSlice = createSlice({
  name: "findMemberList",
  initialState: initialMemberListState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(findMembers.pending, (state: initialMemberListState) => {
      state.loading = true;
    });
    builder.addCase(
      findMembers.fulfilled,
      (state: initialMemberListState, action: PayloadAction<IMember[]>) => {
        console.log("ap..", action.payload);
        state.loading = false;
        state.members = action.payload;
        state.error = "";
      }
    );
    builder.addCase(findMembers.rejected, (state, action) => {
      state.loading = false;
      state.members = [];
      state.error = action.error.message || "Unable to fetch members";
    });
  },
});

export default findMemberSearchResultSlice.reducer;
